import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { BrandIllustration } from '../../../../brand-illustration'

export const DirectContactFormOrderProductsSelectionEmpty: FC<{
  onClose: () => void
}> = ({ onClose }) => (
  <div className="flex flex-col items-center gap-6">
    <BrandIllustration
      alt=""
      name="empty-order-list"
      role="presentation"
      size="m"
      type="dark"
    />
    <p
      className="text-center text-m text-dark-primary-max"
      data-qa-id="contact-form-no-orders-message"
    >
      <FormattedMessage id="direct.contact.form.order.selection.no.eligibleOrders" />
    </p>
    <Button
      className="w-full tablet:w-auto"
      data-qa-id="contact-form-no-orders-close-button"
      onClick={onClose}
      size="medium"
      type="button"
    >
      <FormattedMessage id="direct.contact.form.select.other.subject" />
    </Button>
  </div>
)
